import React from 'react';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { SiLeetcode } from "react-icons/si";

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href='https://www.linkedin.com/in/arjit1804/' target="_blank" rel="noreferrer">
        <BsLinkedin />
      </a> 
    </div>

    <div>
    <a href='https://github.com/arjit1804' target="_blank" rel="noreferrer">
        <BsGithub />
      </a> 
    </div>

    <div>
    <a href='https://leetcode.com/arjit1804/' target="_blank" rel="noreferrer">
        <SiLeetcode />
      </a> 
    </div>
  </div>
);

export default SocialMedia;
